import { Box } from '@mui/material';
import { BRANDING } from '../config/branding';

const CircularProgressCustom = ({ size = 100, imageUrl = BRANDING.logoUrl }) => {
  const strokeWidth = 6;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <Box
      style={{
        position: 'relative',
        width: size,
        height: size,
      }}
      display='flex'
      alignContent='center'
      justifySelf='center'
      alignSelf='center'
      margin={10}
    >
      {/* Imagen PNG de fondo */}
      <img
        src={imageUrl}
        alt="loading"
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          objectFit: 'cover',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />

      {/* Spinner Circular */}
      <svg
        width={size}
        height={size}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          animation: 'spin 1.2s linear infinite',
        }}
      >
        <circle
          stroke={BRANDING.secondaryColor}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * 0.75} // Segmento visible
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
      </svg>

      {/* Animación CSS */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        svg {
          transform-origin: center;
        }
      `}</style>
    </Box>
  );
};

export default CircularProgressCustom;
